import React from 'react';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <div style={styles.page}>
      
      <SEO
        title="Terms of Service"
        description="Driven2WIN terms of service — the terms and conditions that govern use of our website and engagement of our event marketing services."
        canonicalUrl="https://driven2win.com/terms"
        noIndex={true}
      />
      
      <div style={styles.container}>
        <h1 style={styles.h1}>TERMS OF SERVICE</h1>
        <p style={styles.lastUpdated}>Last Updated: March 2026</p>
        
        <div style={styles.content}>
          <section style={styles.section}>
            <h2 style={styles.h2}>Agreement to Terms</h2>
            <p style={styles.p}>
              By accessing or using the Driven2WIN website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Services Description</h2>
            <p style={styles.p}>
              Driven2WIN provides event marketing services for automotive, golf cart, motorcycle, ATV, and RV dealerships, including but not limited to:
            </p>
            <ul style={styles.ul}>
              <li style={styles.li}>Offsite sales events planning and execution</li>
              <li style={styles.li}>Tent setup and permitting services</li>
              <li style={styles.li}>Direct mail marketing campaigns</li>
              <li style={styles.li}>Facebook and Instagram event promotion</li>
              <li style={styles.li}>Related event marketing and promotional services</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Use of Website</h2>
            <p style={styles.p}>You agree to use our website only for lawful purposes and in a manner that does not infringe the rights of others or restrict their use of the website. Prohibited uses include:</p>
            <ul style={styles.ul}>
              <li style={styles.li}>Transmitting harmful, offensive, or illegal content</li>
              <li style={styles.li}>Attempting to gain unauthorized access to our systems</li>
              <li style={styles.li}>Interfering with the proper functioning of the website</li>
              <li style={styles.li}>Using automated systems to scrape or collect data from the website</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Service Agreements</h2>
            <p style={styles.p}>
              Specific terms for event services are established through individual service agreements or contracts. These agreements will outline:
            </p>
            <ul style={styles.ul}>
              <li style={styles.li}>Scope of services provided</li>
              <li style={styles.li}>Pricing and payment terms</li>
              <li style={styles.li}>Timeline and deliverables</li>
              <li style={styles.li}>Performance guarantees and remedies</li>
              <li style={styles.li}>Cancellation and refund policies</li>
            </ul>
            <p style={styles.p}>
              In the event of any conflict between these Terms of Service and a specific service agreement, the service agreement shall prevail.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Intellectual Property</h2>
            <p style={styles.p}>
              All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of Driven2WIN or its content suppliers and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from our content without express written permission.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Performance Guarantees</h2>
            <p style={styles.p}>
              While we guarantee results as outlined in specific service agreements, actual event performance can be affected by factors outside our control, including:
            </p>
            <ul style={styles.ul}>
              <li style={styles.li}>Market conditions and economic factors</li>
              <li style={styles.li}>Weather events and natural disasters</li>
              <li style={styles.li}>Client inventory availability and pricing</li>
              <li style={styles.li}>Sales team performance and follow-up</li>
            </ul>
            <p style={styles.p}>
              Our guarantees are subject to the terms and conditions specified in individual service agreements.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Limitation of Liability</h2>
            <p style={styles.p}>
              To the fullest extent permitted by law, Driven2WIN shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, revenue, or data, arising out of or related to your use of our services or website.
            </p>
            <p style={styles.p}>
              Our total liability for any claims arising from our services shall not exceed the amount paid by you for the specific services in question.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Indemnification</h2>
            <p style={styles.p}>
              You agree to indemnify and hold harmless Driven2WIN, its officers, directors, employees, and agents from any claims, damages, losses, or expenses (including legal fees) arising from your use of our services, violation of these terms, or infringement of any third-party rights.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Payment Terms</h2>
            <p style={styles.p}>
              Payment terms for services are specified in individual service agreements. Generally:
            </p>
            <ul style={styles.ul}>
              <li style={styles.li}>Deposits may be required to secure event dates and initiate services</li>
              <li style={styles.li}>Payment schedules are outlined in service agreements</li>
              <li style={styles.li}>Late payments may be subject to fees and interest</li>
              <li style={styles.li}>Non-payment may result in suspension or termination of services</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Cancellation and Refunds</h2>
            <p style={styles.p}>
              Cancellation and refund policies vary by service type and are detailed in individual service agreements. Generally, deposits and advance payments for services already rendered or committed are non-refundable. Cancellation fees may apply based on timing and services contracted.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Third-Party Services</h2>
            <p style={styles.p}>
              Our services may involve coordination with third-party vendors (e.g., tent rental companies, printing services, venue operators). While we exercise care in selecting vendors, we are not responsible for the acts or omissions of third parties.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Modifications to Terms</h2>
            <p style={styles.p}>
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to this page. Your continued use of our website or services after changes are posted constitutes acceptance of the modified terms.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Governing Law</h2>
            <p style={styles.p}>
              These Terms of Service shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict of law provisions. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Duval County, Florida.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Severability</h2>
            <p style={styles.p}>
              If any provision of these Terms of Service is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.h2}>Contact Information</h2>
            <p style={styles.p}>
              Questions about these Terms of Service should be directed to:
            </p>
            <p style={styles.p}>
              <strong>Driven2WIN</strong><br />
              5285 Shad Road, Suite 1619<br />
              Jacksonville, FL 32257<br />
              Phone: 904-638-7200<br />
              Email: info@driven2win.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// Styles
const styles = {
  page: {
    paddingTop: '109px',
    paddingBottom: '60px',
    background: '#FFFFFF',
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '0 16px', // Mobile-first
  },
  h1: {
    fontFamily: 'Bebas Neue, sans-serif',
    fontSize: '32px', // Mobile-first (auto-scales)
    color: '#1A1F3A',
    marginBottom: '16px',
    letterSpacing: '2px',
  },
  lastUpdated: {
    fontFamily: 'Work Sans, sans-serif',
    fontSize: '14px',
    color: '#999',
    marginBottom: '32px',
    fontStyle: 'italic',
  },
  content: {},
  section: {
    marginBottom: '32px',
  },
  h2: {
    fontFamily: 'Bebas Neue, sans-serif',
    fontSize: '24px', // Mobile-first (auto-scales)
    color: '#E31E24',
    marginBottom: '12px',
    letterSpacing: '1px',
  },
  p: {
    fontFamily: 'Work Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '1.7',
    color: '#333',
    marginBottom: '16px',
  },
  ul: {
    fontFamily: 'Work Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '1.7',
    color: '#333',
    marginLeft: '20px',
    marginBottom: '16px',
  },
  li: {
    marginBottom: '12px',
  },
};

export default TermsPage;
